import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';

/**
	* <b>usage:</b>
	* <br>
	* <element *let="expression as name"></element>
 <br>
	* or
 <br>
	* <element *let="expression; let name"></element>
 <br>
	* or
 <br>
	* <element *let="expression; $ as name"></element>
	*/
@Directive({
	selector: '[let]',
	standalone: true,
})
export class LetDirective<T> {
	private isViewCreated = false;
	private context: LetContext<T> = new LetContext();

	// TODO: Skipped for migration because:

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
	) {}

	//  Accessor inputs cannot be migrated as they are too complex.
	@Input() set let(value: T) {
		//this.context.$ = value;
		this.context.$implicit = this.context.$ = this.context.let = value;
		if (!this.isViewCreated) {
			this.viewContainer.createEmbeddedView(this.templateRef, this.context);
			this.isViewCreated = true;
		}
	}

	static ngTemplateContextGuard<T>(dir: LetDirective<T>, ctx: unknown): ctx is LetContext<T> {
		return true;
	}
}

class LetContext<T> {
	let;
	$implicit: T = undefined;
	$: T = undefined;
}
